@if (!locked()) {
  <ng-content></ng-content>
}
@if (locked()) {
  <span class="dk-locked-placeholder"></span>
}
